import React from 'react';
import { Colors, bgColorClasses } from '@/lib/colorUtils';
import {
  loaderWrapperVariants,
  dotVariants,
  DotLoaderProps,
  DotLoaderSize,
} from './DotLoader.style';

const DOT_DELAYS = [0, 0.15, 0.3] as const;

export const DotLoader = ({
  size = DotLoaderSize.medium,
  color = Colors.colorPrimary,
  'data-cy': dataCy = 'dot-loader',
}: DotLoaderProps) => {
  const bgClass = bgColorClasses[color];

  return (
    <span className={loaderWrapperVariants({ size })} aria-hidden="true" data-cy={dataCy}>
      {DOT_DELAYS.map((delay) => (
        <span
          key={delay}
          className={`${dotVariants({ size })} ${bgClass}`}
          // eslint-disable-next-line react/forbid-dom-props -- dynamic runtime value (per-dot staggered animation delay)
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
    </span>
  );
};

export { DotLoaderSize };
